import { render, staticRenderFns } from "./InvitationJoiningScreen.vue?vue&type=template&id=03fffb8d&scoped=true&"
import script from "./InvitationJoiningScreen.vue?vue&type=script&lang=js&"
export * from "./InvitationJoiningScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fffb8d",
  null
  
)

export default component.exports